import api from 'Application/api/api';

const archiveProject = (id, cancelToken = null) =>
    api.post(`project-manager/projects/${id}/archive`, {}, { cancelToken });

export default archiveProject;
